(function () {
  const SUPABASE_URL = 'https://zhadhjxsnmbnqdpiuiyw.supabase.co';
  const SUPABASE_KEY = 'sb_publishable_99An6wmeGvA4fxS906_I_w_fe0t3DfM';

  const supabase = window.supabase.createClient(SUPABASE_URL, SUPABASE_KEY);
  const REVIEW_BUCKET = 'review-images';
let allImages = [];
  const app = document.getElementById('cudolla-admin-app');

  if (!app) return;

  let allReviews = [];
  let activeFilter = 'all';

  init();

  async function init() {
    const { data: { session } } = await supabase.auth.getSession();

    if (!session) {
      renderLogin();
      return;
    }

    renderDashboard();
    await loadReviews();
  }

  function renderLogin() {
    app.innerHTML = `
      <div class="cud-admin-login">
        <div><h1>CUDOLLA<br>Admin</h1></div>
        <div>
          <p>Sign in to continue.</p>
          <form id="adminLogin">
            <input type="email" id="email" placeholder="Email" required>
            <input type="password" id="password" placeholder="Password" required>
            <button type="submit">Login</button>
          </form>
          <div id="loginMessage"></div>
        </div>
      </div>
    `;

    document.getElementById('adminLogin').addEventListener('submit', login);
  }

  async function login(e) {
    e.preventDefault();

    const email = document.getElementById('email').value;
    const password = document.getElementById('password').value;

    const { error } = await supabase.auth.signInWithPassword({ email, password });

    if (error) {
      document.getElementById('loginMessage').innerHTML = error.message;
      return;
    }

    location.reload();
  }

  function renderDashboard() {
    app.innerHTML = `
      <div class="cud-admin">
        <div class="cud-admin-top">
          <div>
            <h1>Reviews Dashboard</h1>
            <p class="cud-admin-sub">Manage customer reviews, approvals, and private feedback.</p>
          </div>
          <button id="logout">Logout</button>
        </div>

        <div class="cud-admin-stats" id="cud-admin-stats"></div>

        <div class="cud-admin-toolbar">
          <div class="cud-admin-filters">
            <button class="active" data-filter="all">All</button>
            <button data-filter="pending">Pending</button>
            <button data-filter="approved">Approved</button>
            <button data-filter="rejected">Rejected</button>
            <button data-filter="featured">Featured</button>
          </div>
          <input id="cud-admin-search" type="search" placeholder="Search reviews...">
        </div>

        <div id="reviews">Loading...</div>
        <div id="cud-admin-drawer"></div>
      </div>
    `;

    document.getElementById('logout').onclick = logout;

    document.querySelectorAll('.cud-admin-filters button').forEach(button => {
      button.addEventListener('click', function () {
        activeFilter = this.dataset.filter;
        document.querySelectorAll('.cud-admin-filters button').forEach(btn => btn.classList.remove('active'));
        this.classList.add('active');
        renderReviews();
      });
    });

    document.getElementById('cud-admin-search').addEventListener('input', renderReviews);
  }

  async function logout() {
    await supabase.auth.signOut();
    location.reload();
  }

  async function loadReviews() {
    const { data, error } = await supabase
      .from('reviews')
      .select('*')
      .order('created_at', { ascending: false });

    if (error) {
      document.getElementById('reviews').innerHTML = `<div class="cud-admin-error">${escapeHtml(error.message)}</div>`;
      return;
    }

    allReviews = data || [];

await loadImages();

renderStats();
renderReviews();
}
async function loadImages() {
    const { data, error } = await supabase
        .from('review_images')
        .select('*')
        .order('created_at', { ascending: true });

    if (error) {
        console.error('Image load error:', error);
        allImages = [];
        return;
    }

    allImages = data || [];
}

  function renderStats() {
    const pending = allReviews.filter(r => r.status === 'pending').length;
    const approved = allReviews.filter(r => r.status === 'approved').length;
    const rejected = allReviews.filter(r => r.status === 'rejected').length;
    const featured = allReviews.filter(r => r.featured === true).length;

    document.getElementById('cud-admin-stats').innerHTML = `
      <div><strong>${allReviews.length}</strong><span>Total Reviews</span></div>
      <div><strong>${pending}</strong><span>Pending</span></div>
      <div><strong>${approved}</strong><span>Approved</span></div>
      <div><strong>${rejected}</strong><span>Rejected</span></div>
      <div><strong>${featured}</strong><span>Featured</span></div>
    `;
  }

  function renderReviews() {
    const container = document.getElementById('reviews');
    const search = (document.getElementById('cud-admin-search')?.value || '').toLowerCase();

    let reviews = allReviews.slice();

    if (activeFilter !== 'all') {
      reviews = activeFilter === 'featured'
        ? reviews.filter(r => r.featured === true)
        : reviews.filter(r => r.status === activeFilter);
    }

    if (search) {
      reviews = reviews.filter(r => [
        r.first_name, r.email, r.product_title, r.product_handle, r.review_text, r.status
      ].join(' ').toLowerCase().includes(search));
    }

    if (!reviews.length) {
      container.innerHTML = `<div class="cud-admin-empty">No reviews found.</div>`;
      return;
    }

    container.innerHTML = `
      <div class="cud-admin-table">
        <div class="cud-admin-row cud-admin-head">
          <div>Customer</div>
          <div>Rating</div>
          <div>Review</div>
          <div>Status</div>
          <div>Date</div>
        </div>

        ${reviews.map(review => `
          <button class="cud-admin-row cud-admin-review-row" data-review-id="${review.id}">
            <div>
              <strong>${escapeHtml(review.first_name || 'Customer')}</strong>
              <small>${escapeHtml(review.email || '')}</small>
            </div>
            <div class="cud-admin-stars">${'★'.repeat(review.rating || 0)}</div>
            <div><p>${escapeHtml(review.review_text || '').slice(0, 120)}${(review.review_text || '').length > 120 ? '...' : ''}</p></div>
            <div><span class="cud-status ${review.status || 'pending'}">${review.status || 'pending'}</span>
${review.featured ? '<span class="cud-featured-badge">Featured</span>' : ''}</div>
            <div><small>${formatDate(review.created_at)}</small></div>
          </button>
        `).join('')}
      </div>
    `;

    document.querySelectorAll('.cud-admin-review-row').forEach(row => {
      row.addEventListener('click', function () {
        const review = allReviews.find(r => r.id === this.dataset.reviewId);
        if (review) openDrawer(review);
      });
    });
  }

  function renderReviewImages(reviewId) {
  const images = allImages.filter(img => img.review_id === reviewId);

  if (!images.length) {
    return `
      <div class="cud-drawer-box">
        <label>Photos</label>
        <p>No photos uploaded.</p>
      </div>
    `;
  }

  return `
    <div class="cud-drawer-box">
      <label>Photos</label>

      <div class="cud-admin-photo-grid">
        ${images.map(img => `
          <div class="cud-admin-photo-card">
            <img
              class="cud-admin-photo"
              src=""
              data-image-path="${escapeHtml(img.image_path || '')}"
              alt="Review Photo"
            >
          </div>
        `).join('')}
      </div>
    </div>
  `;
}

  function openDrawer(review) {
    const drawer = document.getElementById('cud-admin-drawer');

    drawer.innerHTML = `
      <div class="cud-drawer-backdrop" data-close-drawer></div>

      <aside class="cud-drawer">
        <button class="cud-drawer-close" data-close-drawer>×</button>

        <div class="cud-drawer-kicker">Review Details</div>
        <h2>${escapeHtml(review.first_name || 'Customer')}</h2>

        <div class="cud-drawer-meta">
          <span class="cud-status ${review.status || 'pending'}">${review.status || 'pending'}</span>
          <span>${formatDate(review.created_at)}</span>
        </div>

        <div class="cud-drawer-stars">${'★'.repeat(review.rating || 0)}</div>

        <div class="cud-drawer-box">
          <label>Email</label>
          <p>${escapeHtml(review.email || 'Not provided')}</p>
        </div>

        <div class="cud-drawer-box">
          <label>Review</label>
          <p>${escapeHtml(review.review_text || '')}</p>
        </div>

        <div class="cud-drawer-grid">
          <div><strong>${review.cleanliness_rating || '-'}</strong><span>Cleanliness</span></div>
          <div><strong>${review.communication_rating || '-'}</strong><span>Communication</span></div>
          <div><strong>${review.delivery_rating || '-'}</strong><span>Delivery</span></div>
          <div><strong>${review.would_reserve_again ? 'Yes' : 'No'}</strong><span>Reserve Again</span></div>
        </div>

        ${renderReviewImages(review.id)}

        <div class="cud-drawer-actions">
          <button data-action="approve" data-id="${review.id}">Approve</button>
<button data-action="reject" data-id="${review.id}">Reject</button>
<button data-action="feature" data-id="${review.id}">Feature</button>
<button class="danger" data-action="delete" data-id="${review.id}">Delete</button>
        </div>
      </aside>
    `;

    drawer.classList.add('open');

    drawer.querySelectorAll('[data-close-drawer]').forEach(el => {
      el.addEventListener('click', closeDrawer);
    });

    addPhotoControls(drawer);
    
    drawer.querySelectorAll('[data-action]').forEach(button => {
  button.addEventListener('click', function () {
    handleReviewAction(this.dataset.action, this.dataset.id);
  });
});
  }

  function addPhotoControls(drawer) {
  drawer.querySelectorAll('.cud-admin-photo').forEach(function (photo) {
    if (photo.dataset.controlsAdded === 'true') return;
    photo.dataset.controlsAdded = 'true';

    var path = photo.dataset.imagePath || '';
    var image = allImages.find(function (img) {
      return img.image_path === path;
    });

    if (!image) return;

    supabase.storage
      .from(REVIEW_BUCKET)
      .createSignedUrl(image.image_path, 300)
      .then(function (result) {
        if (!result.error && result.data && result.data.signedUrl) {
          photo.src = result.data.signedUrl;
        }
      });

    var card = photo.closest('.cud-admin-photo-card');

    var status = document.createElement('div');
    status.className = 'cud-photo-mini-status';
    status.textContent = image.status || 'pending';

    var actions = document.createElement('div');
    actions.className = 'cud-photo-mini-actions';

    actions.innerHTML = `
      <button type="button">Approve Photo</button>
      <button type="button">Hide Photo</button>
      <button type="button" class="danger">Delete Photo</button>
    `;

    actions.children[0].onclick = function () {
      handlePhotoAction('approve', image.id);
    };

    actions.children[1].onclick = function () {
      handlePhotoAction('hide', image.id);
    };

    actions.children[2].onclick = function () {
      handlePhotoAction('delete', image.id);
    };

    card.appendChild(status);
    card.appendChild(actions);
  });
}

async function handlePhotoAction(action, id) {
  if (!id) return;

  let updateData = null;

  if (action === 'approve') {
    updateData = {
      status: 'approved',
      visible_publicly: true,
      approved_by_admin: true
    };
  }

  if (action === 'hide') {
  updateData = {
    status: 'rejected',
    visible_publicly: false,
    approved_by_admin: false
  };
}

  if (action === 'delete') {
    if (!confirm('Delete this photo?')) return;

    const { error } = await supabase
      .from('review_images')
      .delete()
      .eq('id', id);

    if (error) {
      alert(error.message);
      return;
    }

    allImages = allImages.filter(img => img.id === id ? false : true);

    const card = document
      .querySelector(`[data-image-path]`)
      ?.closest('.cud-admin-photo-card');

    if (card) {
      card.remove();
    }

    return;
  }

  const { error } = await supabase
    .from('review_images')
    .update(updateData)
    .eq('id', id);

  if (error) {
    alert(error.message);
    return;
  }

  const image = allImages.find(img => img.id === id);

  if (image) {
    Object.assign(image, updateData);
  }

  const status = document
    .querySelector(`[data-image-path="${image.image_path}"]`)
    ?.closest('.cud-admin-photo-card')
    ?.querySelector('.cud-photo-mini-status');

  if (status) {
    status.textContent = updateData.status;
  }
}

  async function handleReviewAction(action, id) {
  if (!id) return;

  if (action === 'delete') {
    const confirmDelete = confirm('Delete this review permanently?');
    if (!confirmDelete) return;

    const { error } = await supabase
      .from('reviews')
      .delete()
      .eq('id', id);

    if (error) {
      alert(error.message);
      return;
    }

    closeDrawer();
    await loadReviews();
    return;
  }

  let updateData = {};

  if (action === 'approve') {
    updateData = {
      status: 'approved',
      verified_reservation: true
    };
  }

  if (action === 'reject') {
    updateData = {
      status: 'rejected',
      featured: false
    };
  }

  if (action === 'feature') {
  const review = allReviews.find(r => r.id === id);
  const makeFeatured = !(review && review.featured);

  updateData = {
    featured: makeFeatured,
    status: makeFeatured ? 'approved' : review.status,
    verified_reservation: makeFeatured ? true : review.verified_reservation
  };
}

  const { error } = await supabase
    .from('reviews')
    .update(updateData)
    .eq('id', id);

  if (error) {
    alert(error.message);
    return;
  }

  closeDrawer();
  await loadReviews();
}
  function closeDrawer() {
    const drawer = document.getElementById('cud-admin-drawer');
    drawer.classList.remove('open');
    drawer.innerHTML = '';
  }

  function formatDate(dateString) {
    if (!dateString) return '';
    return new Date(dateString).toLocaleDateString();
  }

  function escapeHtml(value) {
    return String(value || '')
      .replaceAll('&', '&amp;')
      .replaceAll('<', '&lt;')
      .replaceAll('>', '&gt;')
      .replaceAll('"', '&quot;')
      .replaceAll("'", '&#039;');
  }
})();